export default {
  loggedIn(state) {
    return state.token !== null;
  },
  name(state) {
    return state.name;
  },
  email(state) {
    return state.email;
  },
  scores(state) {
    return state.scores;
  },
  balance(state) {
    return state.balance;
  },
  rates(state) {
    return state.rates;
  },
  giftPayBalance(state) {
    return state.giftPayBalance;
  },
  transactions(state) {
    return state.transactions;
  },
  adminTransactions(state) {
    return state.adminTransactions;
  },
  adminGameTransactions(state) {
    return state.adminGameTransactions;
  },
  rewards(state) {
    return state.rewards;
  },
  adminRewards(state) {
    return state.adminRewards;
  },
  adminFeatures(state) {
    return state.adminFeatures;
  },
  isAdmin(state) {
    return state.isAdmin;
  },
  paymentMethods(state) {
    return state.paymentMethods;
  },
  paymentAmounts(state) {
    return state.paymentAmounts;
  },
    showamount(state) {
      return state.showamount;
    },
    showdaminamount(state) {
      return state.showdaminamount;
    },
    showkelamount(state) {
      return state.showkelamount;
    },
    getwinbankresponseamount(state) {
      return state.winbankresponseamount;
    },
    getwinbankresponsetype(state) {
      return state.winbankresponsetype;
    },
    getfirstname(state) {
      return state.firstname;
    },
    getlastname(state) {
      return state.lastname;
    },
    getregion(state) {
      return state.region;
    },
    geteditProfileMessage(state) {
     return state.editprofilemessage; 
    },
    getDamnToken(state){
      return state.damntoken; 
   },
   getadserverSessionId(state){
    return state.adserversessionid; 
 },
 bannerimage(state){
  return state.bannerimage;
},
getQuizStarBannerList(state){
  return state.quizstarbannerlist;
  },
  getregions(state){
    return state.regions;
 },
 getavatar(state){
  return state.avatar;
},
getUserId(state){
  return state.userid;
},
getpaypalemail(state){
  return state.paypalemail;   
},
getusername(state) {
  return state.username;
},
getDob(state) {
  return state.dob;
},
getGender(state) {
  return state.gender;
},

getStateid(state) {
  return state.stateid;
},
getCityname(state) {
  return state.cityname;
},
getSuburb(state) {
  return state.suburb;
},
getCreditBalance(state){
  return state.creditBalance;
}

}